/**
 * @generated SignedSource<<569fc006a98c258309b649561639ca38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceBanner_productizedService$data = {
  readonly updatedAt: ContraAPIScalars.DateTime;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ServiceBanner_productizedService";
};
export type ServiceBanner_productizedService$key = {
  readonly " $data"?: ServiceBanner_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceBanner_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceBanner_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "f53648de2f4d70f97f77c40569be2093";

export default node;
